import "./App.css";
import { BrowserRouter } from "react-router-dom";
import CartContextProvider from "./components/CartContext";
import BlurContextProvider from "./components/BlurContext";
import MainContent from "./MainContent";

function App() {
	return (
		<BlurContextProvider>
			<CartContextProvider>
				<BrowserRouter>
					<MainContent />
				</BrowserRouter>
			</CartContextProvider>
		</BlurContextProvider>
	);
}

export default App;
